import { IFormViewForm } from 'components/FormView';
const SerialNumber: { [x: string]: IFormViewForm } = {
    SerialNumberForm: {
        id: 'SerialNumberForm',
        layout: {
            rows: 1,
            columns: 2,
        },
        fields: [
            {
                id: '1',
                type: 'PAPER_CONTAINER',
                visible: true,
                props: {
                    name: 'activity',
                    fullWidth: true,
                    elevation: 0
                },
                position: {
                    row: 1,
                    col: 1
                },
                children: [
                    {
                        id: 1,
                        type: 'TEXT_FIELD',
                        props: {
                            label: 'Starting serial',
                            name: 'LotSerial',
                            placeholder: '',
                            size: 'medium',
                        },
                    },
                    {
                        id: 2,
                        type: 'TEXT_FIELD',
                        props: {
                            label: 'Quantity',
                            name: 'Quantity',
                            placeholder: '',
                            size: 'medium',
                            type: 'number',
                        },
                    },
                    {
                        id: 3,
                        type: 'EX_LOOKUP_FIELD',
                        props: {
                            label: 'Bin',
                            name: 'Bin',
                            lookupName: 'ProductBinMaster',
                            isWarehouseProductScoped: true,
                            size: 'small',
                        }
                    },
                    {
                        id: 4,
                        type: 'TOGGLE_FIELD',
                        visible: true,
                        props: {
                            name: 'SaveLocation',
                            label: 'Save product bin location',
                        }
                    },
                ]
            }
        ]
    }
};
export default SerialNumber;
